import { createNewUser, getAllUsers, updateUser } from '../api/users';

const ADD_ALL_USERS = 'ADD_ALL_USERS';
const ADD_NEW_USER = 'ADD_NEW_USER';
const LOADED_ALL_USERS = 'LOADED_ALL_USERS';
const UPDATE_EXISTING_USER = 'UPDATE_EXISTING_USER';

const INITIAL_STATE = {
  isAllUsersLoaded: false,
  users: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ALL_USERS:
      return {
        ...state,
        users: [...action.payload].sort((a, b) => a.displayName.localeCompare(b.displayName)),
      };
    case ADD_NEW_USER:
      return {
        users: [
          ...state.users,
          action.payload,
        ].sort((a, b) => a.displayName.localeCompare(b.displayName)),
      };
    case UPDATE_EXISTING_USER:
      return {
        ...state,
        users: [
          ...state.users.filter(user => user.id !== action.payload.id),
          action.payload,
        ].sort((a, b) => a.displayName.localeCompare(b.displayName)),
      };
    case LOADED_ALL_USERS:
      return {
        ...state,
        isAllUsersLoaded: true,
      };
    default:
      return state;
  }
}

export function fetchAllUsers() {
  return async (dispatch) => {
    try {
      const users = await getAllUsers();

      dispatch({
        type: ADD_ALL_USERS,
        payload: users,
      });

      return dispatch({ type: LOADED_ALL_USERS });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function addNewUser(user) {
  return async (dispatch) => {
    try {
      const u = await createNewUser(user);

      return dispatch({
        type: ADD_NEW_USER,
        payload: u,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function editExistingUser(id, user) {
  return async (dispatch) => {
    try {
      const u = await updateUser(id, user);

      return dispatch({
        type: UPDATE_EXISTING_USER,
        payload: u,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
